import { environment } from '../../environments/environment';

/** Empresas cujas unidades o login lista. Sem `empresasLogin` no build, só a da marca do domínio. */
export function empresasDoLogin(empresaDaMarca: string): string[] {
  const todas = (environment as { empresasLogin?: string[] }).empresasLogin ?? [];
  return todas.length > 0 ? todas : [empresaDaMarca];
}
